module.exports = __webpack_public_path__ + "static/media/g4.7931f9d3.png";